export default [
	{
		type: 'hero',
		slug: 'fish',
		life: 6,
		attack: 1,
		armor: 0,
		gold: 0,
		nb_cards: 5,
		shop_reroll_price: 6,
		hand_reroll_price: 3,
		fr: {
			name: "John",
			description: "John a appris à respirer en même temps qu'il a tenu sa première épée et terrassé son premier ennemi.",
			features: [
				"Pioche plus souvent des armes et boucliers.",
				"Pioche moins souvent de parchemins et potions de soin."
			]
		},
		en: {
			name: "John",
			description: "John has learned to breathe at the same time he held his first sword and defeated his first enemy.",
			features: [
				"Draws weapons and shields more often.",
				"Draws scrolls and healing potions less often."
			]
		},
		talismans: [],
		passives: [],
		triggers: [],
		cards: {
			types: [
				{ type: 'shield', probability: 25 }, 
				{ type: 'weapon', probability: 30 }, 
				{ type: 'gold', probability: 20 }, 
				{ type: 'item', probability: 20 }, 
				{ type: 'scroll', probability: 5 }
			],
			excludes: [ 'cursed-shield', 'feather', 'weakness-potion', 'poison-potion', 'strength-potion' ]
		}
	},
	{
		type: 'hero',
		slug: 'barrel',
		life: 5,
		attack: 1,
		armor: 0,
		gold: 0,
		nb_cards: 6,
		shop_reroll_price: 6,
		hand_reroll_price: 3,
		fr: {
			name: "Barrelio",
			description: "Barrelio est le roi de la furtivité. Il est adepte dans la manipulation du poison, parfois à ses risques et périls.",
			features: [
				"Pioche plus souvent des potions, positives ou négatives.",
				"Pioche moins souvent de parchemins.",
				"Dispose d'une carte supplémentaire en main.",
			]
		},
		en: {
			name: "Barrelio",
			description: "They're the master of stealth. They're skilled with all kinds of poison, at their own risk.",
			features: [
				"Draws potions more often, bad or good.",
				"Draws scrolls less often.",
				"Get one additional card in their hand.",
			]
		},
		talismans: [],
		passives: [],
		triggers: [],
		cards: {
			types: [
				{ type: 'shield', probability: 20 }, 
				{ type: 'weapon', probability: 20 }, 
				{ type: 'gold', probability: 20 }, 
				{ type: 'item', probability: 25 }, 
				{ type: 'scroll', probability: 5 }
			],
			excludes: [ 'feather' ]
		}
	},
	{
		type: 'hero',
		slug: 'carrot',
		life: 6,
		attack: 1,
		armor: 0,
		gold: 0,
		nb_cards: 6,
		shop_reroll_price: 5,
		hand_reroll_price: 2,
		fr: {
			name: "Tokar",
			description: "Tokar n'est pas un grand guerrier mais son sens des affaires lui permet tout de même de grandes aventures.",
			features: [
				"Pioche plus souvent des émeraudes.",
				"Pioche moins souvent des armes et parchemins.",
				"Dispose d'une carte supplémentaire en main.",
				"Réduit le prix de tous les rerolls de 1 émeraude."
			]
		},
		en: {
			name: "Tokar",
			description: "Tokar isn't a great adventurer, but their amazing business acumen enables them to live fantastic journeys.",
			features: [
				"Draws emeralds more often.",
				"Draws weapons and scrolls less often.",
				"Get one additional card in their hand.",
				"Decrease the price of every reroll by 1 emerald."
			]
		},
		talismans: [],
		passives: [],
		triggers: [],
		cards: {
			types: [
				{ type: 'shield', probability: 25 }, 
				{ type: 'weapon', probability: 10 }, 
				{ type: 'gold', probability: 35 }, 
				{ type: 'item', probability: 20 }, 
				{ type: 'scroll', probability: 10 }
			],
			excludes: [ 'feather' ]
		}
	},
	{
		type: 'hero',
		slug: 'spider',
		life: 8,
		attack: 1,
		armor: 0,
		gold: 0,
		nb_cards: 5,
		shop_reroll_price: 6,
		hand_reroll_price: 3,
		fr: {
			name: "Arachnéa",
			description: "La puissance des parchemins n'a aucun secret pour Arachnéa. Espérons que celà lui suffise pour terminer sa quête.",
			features: [
				"Pioche plus souvent des parchemins.",
				"Pioche moins souvent des boucliers et des émeraudes.",
				"Manipule la position des ennemis en les repoussant.",
			]
		},
		en: {
			name: "Arachnéa",
			description: "The power of scrolls has no secret for her ! Let's hope it will be enough to complete her quest.",
			features: [
				"Draws scrolls more often.",
				"Draws fewer shields and emerald.",
				"Control enemies position by pushing them.",
			]
		},
		talismans: [ 'gold-tooth' ],
		passives: [],
		triggers: [],
		cards: {
			types: [
				{ type: 'shield', probability: 10 }, 
				{ type: 'weapon', probability: 30 }, 
				{ type: 'gold', probability: 10 }, 
				{ type: 'item', probability: 15 }, 
				{ type: 'scroll', probability: 35 }
			],
			excludes: []
		}
	},
	{
		type: 'hero',
		slug: 'wolf',
		life: 3,
		attack: 2,
		armor: 1,
		gold: 0,
		nb_cards: 5,
		shop_reroll_price: 6,
		hand_reroll_price: 3,
		fr: {
			name: "Barkbara",
			description: "Barkbara est une guerrière accomplie qui utilise la force brute pour vaincre ses ennemis.",
			features: [
				"Pioche plus souvent des armes et boucliers.",
				"Pioche aucun parchemin",
				"Dispose de peu de santé mais d'un point d'armure par défaut.",
				"Immunisée au poison."
			]
		},
		en: {
			name: "Barkbara",
			description: "She is the berserker of the team, defeating her enemies with brute force.",
			features: [
				"Draws weapons and shields more often.",
				"Never draws scrolls.",
				"Has little health but 1 default armor point.",
				"Immune to poison."
			]
		},
		talismans: [],
		passives: [],
		triggers: [],
		cards: {
			types: [
				{ type: 'shield', probability: 30 }, 
				{ type: 'weapon', probability: 30 }, 
				{ type: 'gold', probability: 15 }, 
				{ type: 'item', probability: 15 }, 
				{ type: 'scroll', probability: 0 }
			],
			excludes: [ 'poison-potion', 'weakness-potion' ]
		}
	},
]